import { FilterOperator } from '#layers/data-model';

// Synthetic UI operator: maps to `{ _null: false }` on the model side.
// Kept as a UI-only token so the dropdown can offer "is null" / "isn't null"
// as separate options while the backend stays on the single `_null: boolean`.
export const UI_NOT_NULL = '_not_null' as const;

export type UIFilterOperator = FilterOperator | typeof UI_NOT_NULL;

export interface ModelOperatorState {
	operator: FilterOperator;
	value: unknown;
}

export interface UIOperatorState {
	operator: UIFilterOperator | undefined;
	value: unknown;
}

export function modelToUi(operator: FilterOperator | undefined, value: unknown): UIFilterOperator | undefined {
	if (operator === FilterOperator.NULL && value === false) return UI_NOT_NULL;
	return operator;
}

export function uiToModel(op: UIFilterOperator, prev: UIOperatorState): ModelOperatorState {
	switch (op) {
		case UI_NOT_NULL:
			return { operator: FilterOperator.NULL, value: false };
		case FilterOperator.NULL:
			return { operator: FilterOperator.NULL, value: true };
	}

	// Switching out of the NULL family discards the synthetic boolean
	const cameFromNull = prev.operator === FilterOperator.NULL || prev.operator === UI_NOT_NULL;
	const inputValue = cameFromNull ? undefined : prev.value;

	switch (op) {
		case FilterOperator.IN:
		case FilterOperator.NIN:
			return { operator: op, value: Array.isArray(inputValue) ? inputValue : [inputValue] };
		case FilterOperator.BETWEEN:
		case FilterOperator.NBETWEEN:
			return { operator: op, value: Array.isArray(inputValue) ? inputValue.slice(0, 2) : [inputValue, null] };
		default:
			return { operator: op, value: Array.isArray(inputValue) ? inputValue[0] : inputValue };
	}
}
